// Version rows carry `version` as a numeric string ('1', '2', …) and exactly one row per workflow
// has `isPublished`. Prefer that flag and fall back to the highest numeric version so a list that
// has not yet settled still resolves deterministically.
const resolveLatestPublishedWorkflowVersion = (versions) => {
  const rows = Array.isArray(versions) ? versions.filter(Boolean) : [];

  if (rows.length === 0) {
    return null;
  }

  const flagged = rows.find((row) => row?.isPublished === true);

  if (flagged) {
    return flagged;
  }

  let best = null;
  let bestNumber = Number.NEGATIVE_INFINITY;

  for (const row of rows) {
    const parsed = Number(row?.version);

    if (Number.isFinite(parsed) && parsed > bestNumber) {
      best = row;
      bestNumber = parsed;
    }
  }

  return best;
};

export default resolveLatestPublishedWorkflowVersion;
